/* eslint @web-monorepo/automatic-translations: "error" */

import { autoTranslate } from "@web-monorepo/translation-runtime";
import { LOGO_CDN_URLS } from "./urls";
import classes from "./DDSLogo.module.css";

export type DDSLogoBrand = "classdojo" | "dojo-tutor" | "dojo-sparks" | "dojo-islands";
export type DDSLogoVariant = "lockup" | "mark";
export type DDSLogoSize = "sm" | "md" | "lg" | "xl";

type DDSLogoProps = {
  brand: DDSLogoBrand;
  variant?: DDSLogoVariant;
  size?: DDSLogoSize;
  className?: string;
  "data-name"?: string;
};

const BRAND_LABELS: Record<DDSLogoBrand, () => string> = {
  classdojo: () => autoTranslate("ClassDojo logo"),
  "dojo-tutor": () => autoTranslate("Dojo Tutor logo"),
  "dojo-sparks": () => autoTranslate("Dojo Sparks logo"),
  "dojo-islands": () => autoTranslate("Dojo Islands logo"),
};

export const DDSLogo = ({ brand, variant = "lockup", size = "md", className, "data-name": dataName }: DDSLogoProps) => {
  const sizeClass = classes[size];
  return (
    <img
      src={LOGO_CDN_URLS[brand][variant]}
      alt={BRAND_LABELS[brand]()}
      className={className ? `${sizeClass} ${className}` : sizeClass}
      data-name={dataName}
    />
  );
};
